import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ubuntu': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM300.7 101C309.5 85.8 329 80.5 344.2 89.3 359.5 98.1 364.7 117.6 355.9 132.9 347.1 148.1 327.6 153.4 312.4 144.6 297.1 135.7 291.9 116.2 300.7 101zM87.4 287.9C69.8 287.9 55.5 273.6 55.5 256 55.5 238.4 69.8 224.1 87.4 224.1 105 224.1 119.3 238.4 119.3 256 119.3 273.6 105 287.9 87.4 287.9zM115.5 291C137.8 273.1 137.9 239.1 115.5 221.1 124.1 188.3 144.6 160.4 172 142L195.7 181.6C144.2 217.9 144.2 294.1 195.7 330.4L172 370C144.6 351.7 124.2 323.7 115.5 291zM344.2 422.7C328.9 431.5 309.5 426.3 300.7 411 291.9 395.7 297.1 376.2 312.4 367.4 327.6 358.6 347.1 363.8 355.9 379.1 364.7 394.4 359.5 413.9 344.2 422.7zM344.5 353.2C317.8 342.9 288.4 359.8 284 388.2 278.8 389.6 235.1 402.5 187.3 378.8L209.8 338.5C266.8 365 333.2 326.8 338.7 264.1L384.8 264.8C382.5 299.3 367.5 330.3 344.5 353.2zM338.6 247.9C333.2 185.9 267.3 146.7 209.7 173.5L187.2 133.2C235.1 109.5 278.7 122.4 283.9 123.8 288.3 152.1 317.7 169.1 344.4 158.8 367.5 181.7 382.4 212.7 384.6 247.3L338.6 247.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ubuntu.js
// module id = kSD/
// module chunks = 144